import React from 'react'
import Layout from '../../components/BridgePage/Layout'
import './index.scss'

const AboutCsap = () => (
  <Layout>
    <div className='aboutCsap'>
      <h1 className='CsapTitle'>Huna Child Sexual Abuse Policy</h1>

      <p>
        Huna enforces a Zero Tolerance Policy against child sexual abuse content or any content that may harm minors. Users are strictly prohibited from using Huna's services to create, publish, reproduce, transmit, distribute, or store such content. This includes, but is not limited to:
      </p>

      <ul>
        <li><strong>Sexualization of Minors:</strong> Any sexually explicit content involving minors or content that sexually exploits minors.</li>
        <li><strong>Sexual Acts Involving Minors:</strong> Content depicting minors participating in sexual activities or encouraging minors to engage in such activities.</li>
        <li><strong>Misleading Content:</strong> Any content targeting young minors that contains:
          <ul>
            <li>Sexual or sexually explicit material.</li>
            <li>Sexual violence.</li>
            <li>Obscene themes.</li>
            <li>Other adult or age-inappropriate themes, such as violence or sexual content.</li>
          </ul>
        </li>
      </ul>

      <p>
        If Huna becomes aware that its services have been used to store and/or transmit such content, we will act immediately to:
      </p>
      <ul>
        <li>Remove any and all offending content.</li>
        <li>Block the user accounts involved.</li>
        <li>Report all related activities to the relevant authorities.</li>
      </ul>

      <p>
        Huna also reserves the right to take further actions, including cooperating with law enforcement agencies or government bodies to assist in prosecuting those involved in such offenses.
      </p>

      <h2>Reporting Child Sexual Abuse Content</h2>
      <p>
        If you are aware of any child sexual abuse or illegal content on the Huna platform, please report it to us at <strong>customer@huna.live</strong> with sufficient information to allow Huna to locate and address the material.
      </p>

      <h2>Additional Resources</h2>
      <p>
        If you come across cases of child exploitation or abuse elsewhere on the internet or offline, we strongly encourage you to reach out to one of the following organizations based on your location:
      </p>
      <ul>
        <li><strong>North America, Australia, New Zealand:</strong> <a href="https://www.missingkids.org/gethelpnow/cybertipline" target="_blank" rel="noreferrer">National Center for Missing & Exploited Children (NCMEC)</a></li>
        <li><strong>Europe:</strong><a href="https://www.europol.europa.eu/report-a-crime/law-enforcement-reporting-channels-child-sexual-coercion-and-extortion" target="_blank" rel="noreferrer"> Local law enforcement reporting channels for child sexual coercion and extortion.</a></li>
        <li><strong>South America and Other Regions:</strong> <a href="https://www.icmec.org/education-portal/reporting-mechanisms/" target="_blank" rel="noreferrer"> International Centre for Missing & Exploited Children (ICMEC) global hotline.</a></li>
      </ul>
    </div>
  </Layout>
)

export default AboutCsap
